// React import not needed with React 19+ JSX transform
import { AvatarPreview } from "@/components/ui/avatar-preview";
import type { FieldConfig } from "../types";

interface AvatarPreviewFieldProps<T> {
  field: FieldConfig<T>;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  id: string;
  placeholder?: string;
  "aria-describedby"?: string;
}

export function AvatarPreviewField<T>({
  field,
  value,
  onChange,
  onBlur,
  disabled,
  id,
  placeholder,
  "aria-describedby": ariaDescribedBy,
}: AvatarPreviewFieldProps<T>) {
  // Extract initials from field context if available
  // This could be enhanced to receive firstname/lastname from parent form
  const fallbackText = field.fallbackText || "?";
  
  // Compute merged values once using nullish coalescing
  const mergedDisabled = disabled ?? field.disabled;
  const mergedPlaceholder = placeholder ?? field.placeholder;
  
  return (
    <AvatarPreview
      id={id}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={mergedDisabled}
      placeholder={mergedPlaceholder}
      fallbackText={fallbackText}
      size="md"
      aria-describedby={ariaDescribedBy}
    />
  );
}